import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservationService {

  observations: Array<any> = [];
  observationsList: Array<any> = [];
  editObservation: any = {};
  observationSession: any = {};
  editForm = new Subject<any>();
  resetForm = new Subject<void>();
  enableView = false;
  enableEdit = false;
  editID = 0;
  viewID = 0;
  observedQuotaCount = 0;
  
  constructor() { }

  newObservation(){
    this.editObservation = {};
    this.observations = [];
    this.observationSession = {};
    this.observationsList = [];
  }
}
